import React from 'react';
import routeConfiguration from '../../../routeConfiguration';
import { validFilterParams } from '../../../containers/SearchPage/SearchPage.helpers';
import { CURRENT_LOCATION_ID } from '../../../util/googleMaps';
import { createResourceLocatorString } from '../../../util/routes';
import { parse } from '../../../util/urlHelpers';
import { IconCompassFilledL, IconCompassL } from '../../../icons';
import { geocoderInstance } from '../../../services/GeocoderGoogleMaps';
import { setUserCurrentLocationSP } from '../../../util/localStorage';
import { userLocationSearchParamsMatch } from '../../../util/location';
import { fitMapToBounds } from '../SearchMap.helpers';
import css from '../MapWithGoogleMap.css';
import Button from '../../Button/Button';
import { useDispatch } from 'react-redux';
import { setMapBounds } from '../../../containers/SearchPage/SearchPage.duck';

const currentLocationData = {
    id: CURRENT_LOCATION_ID,
    predictionPlace: {},
};

export default ({ location, filters, history, mapEl }) => {
    const dispatch = useDispatch();
    const onMapBoundsSetting = bounds => dispatch(setMapBounds(bounds));

    const { page, ...searchInURL } = parse(location.search, {
        latlng: ['origin'],
        latlngBounds: ['bounds'],
    });
    const { mapSearch, listingType, ...rest } = searchInURL;

    const isCurrentUserLocation = userLocationSearchParamsMatch(rest);

    const navigateToUserLocation = () => {
        if (!geocoderInstance) return;

        geocoderInstance.getPlaceDetails(currentLocationData).then(response => {
            const { address, origin, bounds } = response;
            const searchParams = {
                address,
                origin,
                bounds,
                mapSearch: false,
                listingType,
                ...validFilterParams(rest, filters),
                mapView: rest.mapView,
            };

            if (bounds) {
                onMapBoundsSetting(bounds);
            }

            setUserCurrentLocationSP({ address, origin });

            history.push(
                createResourceLocatorString('SearchPage', routeConfiguration(), {}, searchParams)
            );

            mapEl &&
                fitMapToBounds({
                    map: mapEl,
                    bounds,
                });
        });
    };

    return (
        <Button className={css.currentLocationControlElem} onClick={() => navigateToUserLocation()}>
            {isCurrentUserLocation ? (
                <IconCompassFilledL rootClassName={css.currentLocationMarkerFilled} />
            ) : (
                <IconCompassL />
            )}
        </Button>
    );
};
